import { render, staticRenderFns } from "./ProfileManagerCounts.vue?vue&type=template&id=65203e68"
import script from "./ProfileManagerCounts.vue?vue&type=script&lang=js"
export * from "./ProfileManagerCounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports